/**
 * Stable CSS class names for E2E — Product comments / Comment detail page.
 */
export const CD = {
    page: 'product-comments-comment-detail-page',
    formSection: 'product-comments-comment-detail-page__form-section',
} as const;

export const cdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

